import * as React from 'react';
export const kookminSvg = React.forwardRef(function kookminSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#FCAF17',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M27.434 15.77c-.71-.673-1.698-.969-3.014-.893-1.099.063-1.968.477-2.632.867 0-.333.038-.703.079-1.056.04-.352.079-.71.079-1.05 0-.339-.04-.672-.165-.955a.198.198 0 0 0-.19-.113c-.356.006-1.047.239-1.218.383l-.092.189c0 .377-.092 1.42-.178 1.546l-.046.126c-.151 1.496-.151 2.81-.013 3.94.013.114.243.284.421.347.19.069.796-.088 1.145-.214l.132-.019c.235-.026.174-.376.177-.54.25-.975 1.27-2.137 2.468-2.313.678-.101 1.218.062 1.639.502.059.082.184.78-.27 1.584-.336.597-1 1.1-1.875 1.415-.83.301-1.744.42-2.87.39-.046-.032-1.06-.686-1.06-.686-.894-.597-2.006-1.345-3.013-1.71-.178-.062-.494-.314-.685-.471l-.105-.082c-.579-.446-1.685-1.15-2.58-1.716l-.48-.308v-.094l.586-.346c.458-.253.894-.544 1.322-.817.007 0 1.935-1.05 1.935-1.05 1.863-.974 3.968-2.08 5.074-3.174.063-.203.33-1.019-.06-1.08-.861-.082-1.98.408-2.994 1.32-.232.209-.504.343-.776.49-1.119.61-3.64 2.099-4.962 2.903.086-1.357.349-3.28.671-4.89l-.033-.188c-.204-.363-.45-.575-.908-.465-.208.074-.668.122-.756.333-.632 1.452-1.159 3.847-1.284 5.757-.946-.577-2.008-1.263-3.073-1.602-.204-.026-.454-.17-.698-.308-.026-.013-.48-.296-.48-.296l-.73-.446-.191-.044c-.316.05-.915.44-1.1.704-.1.143.026.366.067.509.348.346 1.237.918 2.099 1.358l1.007.509 1.54.804c.152.117.3.238.473.32-.408.265-2.796 1.786-2.796 1.786l-1.475.93c-.138.094-.717.34-.848.39-.316.126-.56.314-.659.521L4 18.85c0 .151.27.365.619.365.256.012.644-.132 1.355-.434.658-.277 2.448-1.307 3.212-1.747.459-.255.948-.579 1.434-.773l.23-.12c0 1.725.076 3.498.422 5.192l.026.075c.125.176.27.704.395 1.176l.29.93c.27.301.792.39 1.177.333.08-.17.092-.352.092-.54 0-.31-.028-.621-.052-.93-.122-1.805-.217-3.616-.217-5.425.276.17 1.494.899 1.494.899 2.066 1.282 5.185 3.212 7.067 3.72.21.054.441-.16.612-.257.106-.05.178-.226.191-.408 1.586-.076 3.804-.66 4.988-2.087A2.87 2.87 0 0 0 28 17.014c0-.472-.316-1.025-.566-1.245Z',
      fill: '#fff',
    }),
  );
});
kookminSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var kookmin = {
  category: 'brand',
  colorable: false,
  name: 'kookmin',
  svg: kookminSvg,
};
